export default __webpack_public_path__ + "static/media/img-proj-om-merchant.5c7775f8.png";